import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import VueMeta from "vue-meta";
import store from "../store"; // Import your store

Vue.use(VueRouter);
Vue.use(VueMeta);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) =>
    new Promise(() => {
      const position = savedPosition || {};
      if (!savedPosition) {
        if (to.hash) {
          position.selector = to.hash;
        }
        if (to.matched.some((m) => m.meta.scrollToTop)) {
          position.x = 0;
          position.y = 0;
        }
      }
      window.scrollTo(position.x, position.y);
    }),
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "WizFit";

  if (to.meta.isPublic && !to.query.school_id) {
    const schoolId = store.getters["publicDonationPage/getSchoolId"];
    if (schoolId) {
      next({
        ...to,
        query: { ...to.query, school_id: schoolId },
      });
      return;
    }
  }

  next();
});

// ✅ Add this block to avoid redundant navigation globally
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (this.currentRoute.fullPath === this.resolve(location).route.fullPath) {
    return Promise.resolve(this.currentRoute);
  }
  return originalPush.call(this, location, onResolve, onReject);
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (this.currentRoute.fullPath === this.resolve(location).route.fullPath) {
    return Promise.resolve(this.currentRoute);
  }
  return originalReplace.call(this, location, onResolve, onReject);
};

export default router;
